/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ReferenceMeasurementState = {
    Undefined: 'Undefined',
    Valid: 'Valid',
    CalibrationMissing: 'CalibrationMissing',
    Outdated: 'Outdated'
} as const;
export type ReferenceMeasurementState = typeof ReferenceMeasurementState[keyof typeof ReferenceMeasurementState];


export function ReferenceMeasurementStateFromJSON(json: any): ReferenceMeasurementState {
    return ReferenceMeasurementStateFromJSONTyped(json, false);
}

export function ReferenceMeasurementStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferenceMeasurementState {
    return json as ReferenceMeasurementState;
}

export function ReferenceMeasurementStateToJSON(value?: ReferenceMeasurementState | null): any {
    return value as any;
}

/**
 * Check if a given object implements the ReferenceMeasurementState interface.
 */
 export function instanceOfReferenceMeasurementState(value: any): value is ReferenceMeasurementState {
    return Object.values(ReferenceMeasurementState).includes(value)
}

